import { render, staticRenderFns } from "./popup_IPN.vue?vue&type=template&id=624e6566"
import script from "./popup_IPN.vue?vue&type=script&lang=js"
export * from "./popup_IPN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports